{
  "add_reply": "Reply...",
  "title": "Title",
  "description": "Description",
  "upload_video": "Upload video",
  "video_submit": "Submit video",
  "add_tag": "Add tag",
  "field_required": "This field is required",
  "at_time": "Add comment with timestamp",
  "at_page": "Add comment to current page"
}
